export const ASPECT_RATIO = {
  ARTICLE: 1.8,
  NO_RATIO: 0,
  SQUARE: 1,
  EARTH_ICON: 0.74,
  SPOTLIGHT_ICON: 1.073,
  CAROUSEL_SLIDE: 2,
  TOP_SECTION_ICONS: 1.1548
}

export const REQUIRED_DIMENSIONS_BY_RATIO = {
  '1.8': {
    minWidth: 900,
    minHeight: 500
  }
}

export function getDimensionsByRatio(ratio) {
  if (!ratio) return null

  return REQUIRED_DIMENSIONS_BY_RATIO[ratio.toString()] || null
}
